import { jsx } from "panel";
import {
  RowLabelType,
  SelectorTypeDefinitions
} from "common/query-builder/query-entry-section/types";
import { StringOperator } from "common/widgets/property-filter-menu/models/types";
import { QueryEntrySectionEl } from "common/query-builder/query-entry-section/panel";
import { getProjectId, getWorkspaceId } from "common/report/util";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import nonOverlappingSegmentsImg from "common/assets/images/custom-groups/nonoverlapping-segments.svg";
export function template() {
  const segment = this.params.segment;
  const listProperty = this.params.listProperty;
  const filters = this.getFilters();
  const commonEntryParams = {
    filters: [],
    filterOnly: true,
    hideListQuantifier: true,
    quickDelete: true,
    suppressTracking: true,
    type: SelectorTypeDefinitions.Filter,
    event: this.createTemplateFilter(segment).getAttributes()
  };
  const placeholderRow = {
    ...commonEntryParams,
    quickDelete: false,
    operatorOverrides: this.getFilterOperatorOverrides(filters.length)
  };
  const disableFilterSection = filters.length >= 10;
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-string-bucket-pane"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".input-area"
  }, /* @__PURE__ */ jsx(QueryEntrySectionEl, {
    containedSection: true,
    indentFilters: true,
    disableAddEntry: true,
    disabled: disableFilterSection,
    rowIndex: 0,
    rowLabelType: RowLabelType.None,
    addEntryButtonLabel: "Select Value",
    entries: [
      ...filters.map((event, idx) => ({
        ...commonEntryParams,
        event,
        quickRename: event.filterOperator === StringOperator.Equals,
        operatorOverrides: this.getFilterOperatorOverrides(idx)
      })),
      placeholderRow
    ],
    eventNames: this.params.eventNames,
    projectId: parseInt(getProjectId()),
    workspaceId: parseInt(getWorkspaceId()),
    rowTypes: [{ placeholderEntry: commonEntryParams, value: SelectorTypeDefinitions.Filter }],
    trackProperties: { sectionName: `customize-string-group` },
    onUpdate: (updates) => this.handleFiltersUpdate(updates),
    onKeyUp: (ev) => ev.stopPropagation(),
    ...listProperty ? { listProperty } : {}
  }), /* @__PURE__ */ jsx("div", {
    sel: ".remaining-values"
  }, /* @__PURE__ */ jsx("span", null, "Else remaining values"), /* @__PURE__ */ jsx("div", {
    sel: ".help-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info-xs` }
  }), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      "image-src": nonOverlappingSegmentsImg,
      "max-width": `150px`,
      placement: Placement.RightCenter,
      text: `All other values will be
included in this group`
    }
  })))));
}
